import { useEffect, useRef } from "react";
import { useGetCurrentUser } from "~/api/users/users";
import { trackEvent } from "~/utils/analytics";

export const useTrackPageVisit = (eventName: string) => {
  const { data: userInfo } = useGetCurrentUser();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!userInfo?.email) {
      return;
    }
    if (!hasTracked.current) {
      trackEvent({ eventName });
      hasTracked.current = true;
    }
  }, [eventName, userInfo]);
};
